import { userProfileConstants } from '../../_constants';
import { userProfileService } from '../../_services';

export const setPasswordAction = {
    setPasswordHandler
};

function setPasswordHandler(data, call) {
    return dispatch => {
        dispatch(request(call));
        userProfileService.setPasswordHandler(data, call)
            .then(
                setPassword => {
                    dispatch(success(setPassword,call));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request(call) { return { type: userProfileConstants.REQUEST_SET_PASSWORD, call: call} }
    function success(setPassword, call) { return { type: userProfileConstants.RECEIVE_SET_PASSWORD, setPassword, call: call } }
    function failure(error) { return { type: userProfileConstants.SET_PASSWORD_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/UserProfile/setPassword.action.js